module.exports = __webpack_public_path__ + "media/customizations/lmdb/logo-new-abab5b5c03ec7289e8bc43e2757e735e.png";